import React, { useCallback, useEffect } from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { number, object } from "yup"
import { autoEuropePricingIdDrawerData, autoEuropePricingIdDrawerErrors } from "Pages/AutoEuropeTool/PricingId/@signals"

export default function AutoEuropeOptionalPricingIdField({ fieldKey, label }) {
	const value = autoEuropePricingIdDrawerData.value[fieldKey] ?? null

	const { errors, isValid } = useValidatorSeeker({ [fieldKey]: value }, object({
		[fieldKey]: number()
			.typeError(`${label} must be a number`)
			.integer(`${label} must be an integer`)
			.positive(`${label} must be a positive number`)
			.nullable()
			.optional(),
	}))

	useEffect(() => {
		autoEuropePricingIdDrawerErrors.value = { ...autoEuropePricingIdDrawerErrors.value, [fieldKey]: isValid }
	}, [JSON.stringify(errors)])

	const onChange = useCallback((e) => {
		autoEuropePricingIdDrawerData.value = {
			...autoEuropePricingIdDrawerData.value,
			[fieldKey]: e.target.value === '' ? null : Number(e.target.value),
		}
	}, [fieldKey])

	return <TextFieldSeeker
		label={label}
		type="number"
		value={value ?? ""}
		onChange={onChange}
		error={errors?.[fieldKey]}
	/>
}
